__turbopack_context__.v({
  "chartWrapper": "profile-module-scss-module__MZ5-ia__chartWrapper",
  "chartWrapperFullWidth": "profile-module-scss-module__MZ5-ia__chartWrapperFullWidth",
  "profileLayout": "profile-module-scss-module__MZ5-ia__profileLayout",
  "topParentsWrapper": "profile-module-scss-module__MZ5-ia__topParentsWrapper",
});
